'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.allowedTextFieldProperties = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _WMTextField = require('../WMTextField');

var _WMTextField2 = _interopRequireDefault(_WMTextField);

var _PropertyHelper = require('../common/PropertyHelper');

var _isValid = require('./isValid');

var _isValid2 = _interopRequireDefault(_isValid);

var _filter = require('./filter');

var _filter2 = _interopRequireDefault(_filter);

var _WMRequiredLabel = require('../WMRequiredLabel');

var _WMRequiredLabel2 = _interopRequireDefault(_WMRequiredLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = _extends({}, _WMTextField.propTypes, {
	filter: _propTypes2.default.func,
	criteria: _propTypes2.default.oneOf(['canadian postal code', 'zip', 'email', 'credit card', 'FQDN', 'url']),
	trim: _propTypes2.default.bool,
	exclude: _propTypes2.default.string,
	include: _propTypes2.default.string,
	min: _propTypes2.default.number,
	max: _propTypes2.default.number,
	limitOnMax: _propTypes2.default.bool,
	name: _propTypes2.default.string.isRequired,
	errorName: _propTypes2.default.string.isRequired,
	onValidate: _propTypes2.default.func,
	floatingLabelText: _propTypes2.default.node.isRequired,
	floatingLabelFixed: _propTypes2.default.bool,
	floatingLabelColorsFixed: _propTypes2.default.bool,
	regex: _propTypes2.default.instanceOf(RegExp),
	required: _propTypes2.default.bool,
	errorText: _propTypes2.default.string,
	valid: _propTypes2.default.bool,
	hintText: _propTypes2.default.string
});

var allowedTextFieldProperties = exports.allowedTextFieldProperties = Object.keys(_WMTextField.propTypes);

var WMValidatingTextField = function (_Component) {
	_inherits(WMValidatingTextField, _Component);

	function WMValidatingTextField(props) {
		_classCallCheck(this, WMValidatingTextField);

		var _this = _possibleConstructorReturn(this, (WMValidatingTextField.__proto__ || Object.getPrototypeOf(WMValidatingTextField)).call(this, props));

		_initialiseProps.call(_this);

		_this.state = {
			dirty: false,
			blurred: false,
			valid: false
		};
		return _this;
	}

	_createClass(WMValidatingTextField, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.performValidation(this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (typeof nextProps.valid !== 'undefined' && nextProps.valid !== this.state.valid) {
				this.setState({ valid: nextProps.valid });
			}

			if (nextProps.value === this.props.value) {
				return;
			}

			this.performValidation(nextProps);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			var validationResult = {
				name: this.props.name,
				isValid: true,
				value: this.props.value
			};

			if (this.props.onValidate) {
				this.props.onValidate(validationResult);
			}
			if (this.context.onValidate) {
				this.context.onValidate(validationResult);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    name = _props.name,
			    children = _props.children,
			    errorName = _props.errorName,
			    errorText = _props.errorText,
			    required = _props.required,
			    floatingLabelText = _props.floatingLabelText,
			    floatingLabelFixed = _props.floatingLabelFixed,
			    floatingLabelColorsFixed = _props.floatingLabelColorsFixed,
			    hintText = _props.hintText;
			var _state = this.state,
			    dirty = _state.dirty,
			    blurred = _state.blurred,
			    valid = _state.valid;

			var canValidate = dirty && blurred;

			return _react2.default.createElement(
				_WMTextField2.default,
				_extends({}, (0, _PropertyHelper.filter)(this.props, allowedTextFieldProperties), {
					onChange: function onChange(event, value) {
						return _this2.onChange(name, value);
					},
					onBlur: function onBlur() {
						return _this2.onBlur(name);
					},
					hintText: hintText,
					floatingLabelFixed: floatingLabelFixed,
					floatingLabelText: _react2.default.createElement(_WMRequiredLabel2.default, {
						label: floatingLabelText,
						required: required,
						valid: canValidate ? valid : true,
						colorsFixed: floatingLabelColorsFixed
					}),
					errorText: canValidate && !valid && (errorText || 'Please enter a valid ' + errorName)
				}),
				children
			);
		}
	}]);

	return WMValidatingTextField;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
	var _this3 = this;

	this.onChange = function (event, value) {
		if (!_this3.state.dirty) {
			_this3.setState({
				dirty: true
			});
		}

		if (_this3.props.onChange) {
			_this3.props.onChange(_this3.props.name, (0, _filter2.default)(value, _this3.props));
		}
	};

	this.onBlur = function (event) {
		if (!_this3.state.blurred) {
			_this3.setState({
				blurred: true
			});
		}

		if (_this3.props.onBlur) {
			_this3.props.onBlur(event, _this3.props.name);
		}
	};

	this.performValidation = function (props) {
		var validity = (0, _isValid2.default)(props);
		var validationResult = {
			name: props.name,
			isValid: validity,
			value: props.value
		};
		_this3.setState({
			valid: validity
		});

		if (props.onValidate) {
			props.onValidate(validationResult);
		}

		if (_this3.context.onValidate) {
			_this3.context.onValidate(validationResult);
		}
	};
};

WMValidatingTextField.contextTypes = {
	onValidate: _propTypes2.default.func
};

exports.default = WMValidatingTextField;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMValidatingTextField/index.js